import React, { useContext } from "react";
import { FooterContainer, FooterTextRow, MemberButton } from "./Layout.styles";
import { FlexDiv, StyledP, StyledSpan } from "../../base/BaseStyle";
import icon from "../../assets/images/whiteIcon.png";
import Button from "../Button";
import AppModel from "../../models/appModel";
import { SIGNUP_PATH } from "../../constants/paths";
import UserModel from "../../models/userModel";

export default function Footer() {
  const { navigate } = useContext(AppModel.Context);
  const { token } = useContext(UserModel.Context);
  return (
    <FooterContainer>
      <FooterTextRow>
        <StyledSpan color="white" fontSize="20" sx={{ fontSize: 15 }}>
          成為Chaingate會員
        </StyledSpan>

        <FlexDiv>
          <StyledSpan
            color="white"
            fontSize="20"
            margin="0px 0px 0px 10px"
            sx={{ fontSize: 15, margin: "0px" }}
          >
            尊享
          </StyledSpan>
          <StyledSpan
            color="secondary"
            fontSize="20"
            sx={{ fontSize: 15 }}
            fontWeight="bold"
          >
            無盡優惠
          </StyledSpan>
          <StyledSpan color="white" fontSize="20" sx={{ fontSize: 15 }}>
            !
          </StyledSpan>
        </FlexDiv>

        {!token && (
          <Button
            type="button"
            sx={{ marginTop: 20 }}
            onClick={() => {
              navigate(SIGNUP_PATH);
            }}
          >
            <img src={icon} alt="" />
            成為會員
          </Button>
        )}
      </FooterTextRow>

      <FlexDiv style={{ marginTop: 20 }}>
        <StyledP color="white">| 條款及細則</StyledP>
        <StyledP color="white" margin="0px 5px">
          | 私隱政策
        </StyledP>
        <StyledP color="white" margin="0px 5px">
          | 聯絡我們 : xxxx xxxx
        </StyledP>
      </FlexDiv>

      <StyledP color="white" fontSize="12">
        Copyright© owned by Chaingate
      </StyledP>
    </FooterContainer>
  );
}
